<alert></alert>
<div class="mobileSeparator d-none"></div>
<div id="contactContainer" class="container">
    <div class="row">
        <div id="contactTitle" class="col">
            <h3 class="text-center mb-5">{{ 'contactPage.title' | translate }}</h3>
        </div>
    </div>
    <div class="row">
        <div id="contactMessage" class="col-lg-6 mobDiv">
            <h2 class="ml-5">{{ 'landingPage.title' | translate }}</h2>
            <p> {{ 'contactPage.description' | translate}}
                <br>
                <a href="/assets/test.pdf" target="_blank" class="bold dwLink">PDF</a>
            </p>
            <ul class="list-unstyled contact-info">
                <li>
                        {{ 'contactPage.direccion' | translate}}
                </li>
                <li>
                    Habana Vieja, CP 10100 La Habana, Cuba
                </li>
                <li>
                        {{ 'contactPage.reservaciones' | translate}} +53 5698 5782 (De 8:30 hrs a 17:00 hrs)
                </li>
                <li>
                        {{ 'contactPage.emergencias' | translate}} +53 5698 5782
                </li>
            </ul>
        </div>
        <div class="col-lg-6">
            <form [formGroup]="contactForm" class="ml-5" (ngSubmit)="contact()">
                <div class="form-row">
                    <div class="form-group col-6 col-sm-4" [ngClass]="{'formError': submitted && f.name.errors}">
                        <label for="name">{{ 'contactPage.name' | translate }}</label>
                        <input id="name" class="form-control" formControlName="name">
                        <!-- <div class="text-danger mt-1" *ngIf="submitted && f.name.errors">
                            <div *ngIf="f.name.errors.required">name pattern error</div>
                        </div> -->
                    </div>

                    <div class="form-group col-6 col-sm-4" [ngClass]="{'formError': submitted && f.email.errors}">
                        <label for="contactEmail">{{ 'contactPage.email' | translate }}*</label>
                        <input type="email" id="contactEmail" formControlName="email" class="form-control">
                        <div class="text-danger mt-1" *ngIf="submitted && f.email.errors">
                            <div *ngIf="f.email.errors.required">{{ 'contactPage.emailErrorRequired' | translate }}
                            </div>
                            <div *ngIf="f.email.errors.email">{{ 'contactPage.emailErrorPattern' | translate }}</div>
                        </div>
                    </div>
                </div>

                <div class="form-group col-12 col-sm-8 px-0" [ngClass]="{'formError': submitted && f.phone.errors}">
                    <label for="contactPhone">{{ 'contactPage.phone' | translate }}</label>
                    <input type="text" id="contactPhone" formControlName="phone" class="form-control ">
                    <div class="text-danger mt-1" *ngIf="submitted && f.phone.errors">
                        <div *ngIf="f.phone.errors.pattern">{{ 'contactPage.phoneErrorPattern' | translate }}</div>
                    </div>
                </div>

                <div class="form-group" [ngClass]="{'formError': submitted && f.commentary.errors}">
                    <label for="contactCommentary">{{ 'contactPage.commentary' | translate }}*</label>
                    <textarea type="text" id="contactCommentary" formControlName="commentary" rows="6"
                        class="form-control"></textarea>
                    <div class="text-danger mt-1" *ngIf="submitted && f.commentary.errors">
                        <div *ngIf="f.commentary.errors.required">
                            {{ 'contactPage.commentaryErrorRequired' | translate }}</div>
                        <div *ngIf="f.commentary.errors.maxlength">
                            {{ 'contactPage.commentaryErrorMaxlength' | translate }}</div>
                    </div>
                </div>

                <button id="contactSubmit" type="submit"
                    class="buttonPrimary">{{ 'contactPage.send' | translate }}</button>
            </form>
        </div>
    </div>
    <div class="text-center mt-5 mb-2">
        <app-airbnb-button></app-airbnb-button>
    </div>
</div>